import React from 'react';
import { useLocation } from 'react-router-dom';

import {
  InputLabel
} from 'components/form/prototypes';

const CreatedBy = () => {
  const location = useLocation();

  const isDisabled = true;
  var label = "NCR Raised By";

  if (location.pathname === "/create_return" || location.pathname.includes("/return")) {
    label = "Return Raised By"
  }

  return (
    <InputLabel
      name='ncr.created_by'
      label={label}
      disabled={isDisabled} />
  )
}

export { CreatedBy };
